import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const forgeAdminRoute: InvariantJiraRoute = {
	name: 'forge-spa-admin',
	path: '/jira/settings/apps/:appId/:envId/:route?',
};
